import { resolveColor } from 'src/ui/styles/utils/colors';
import styled from 'styled-components';
import { ModalContent, ModalHeader } from 'ui/molecules/modal';

export const SideOverlayHeader = styled(ModalHeader)`
  background-color: ${({ theme }) => theme.sidebar.color};
  padding: 1.5rem;
  justify-content: space-between;
`;

export const SideOverlayContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  width: 100vw;
  padding: 0;
  color: white;
  background-color: ${({ theme }) => theme.sidebar.color};
`;

export const NavWrapper = styled.div`
  height: 100%;
`;

export const Footer = styled.div`
  position: sticky;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  bottom: 0;
  background-color: ${({ theme }) => resolveColor(theme, 'background')};
  margin-top: auto;
  ${({ theme }) => `padding: ${theme.sidebar.paddingSmall}px;`};
`;
